import { slideshowStyles as styles } from "@insite/content-library/Widgets/Basic/Slideshow";
import getColor from "@insite/mobius/utilities/getColor";
import { typography } from "@solveindustrial/Utilities/styleguide/typography";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.prevArrowWrapper = {
    ...styles.prevArrowWrapper,
    css: css`
        ${styles.prevArrowWrapper?.css}

        && {
            padding-left: 20px;
        }
    `,
};

styles.dotsContainerWrapper = {
    ...styles.dotsContainerWrapper,
    css: css`
        ${styles.dotsContainerWrapper?.css}
        margin-top: -50px;

        && {
            justify-content: center;
            padding: 0 80px;
            gap: 16px;

            ${mediaQueriesBP.minMD} {
                justify-content: flex-end;
            }
        }
    `,
};

styles.dotButton = {
    ...styles.dotButton,
    css: css`
        ${styles.dotButton?.css}

        && {
            border-radius: 50%;
            height: 8px;
            width: 8px;
            min-height: auto;
            padding: 0;
            margin: 0;
        }

        &:active,
        &:hover,
        &:focus {
            background-color: ${getColor(colorStrings.commonGlobalWhite)};
            padding: 0;
        }
    `,
};

styles.nextArrowWrapper = {
    ...styles.nextArrowWrapper,
    css: css`
        ${styles.nextArrowWrapper?.css}

        && {
            padding-right: 20px;
        }
    `,
};

styles.nextArrowButton = {
    ...styles.nextArrowButton,
    css: css`
        ${styles.nextArrowButton?.css}

        padding: 0;

        &:active,
        &:not(:disabled):hover,
        &:hover,
        &:focus {
            background-color: ${getColor(colorStrings.commonGlobalWhite)};

            svg {
                color: ${getColor(colorStrings.primaryMain)};
            }
        }

        ${mediaQueriesBP.minMD} {
            padding: 0;
        }
    `,
};

styles.prevArrowButton = {
    ...styles.prevArrowButton,
    css: css`
        ${styles.prevArrowButton?.css}

        padding: 0;

        &:active,
        &:not(:disabled):hover,
        &:hover,
        &:focus {
            background-color: ${getColor(colorStrings.commonGlobalWhite)};

            svg {
                color: ${getColor(colorStrings.primaryMain)};
            }
        }

        ${mediaQueriesBP.minMD} {
            padding: 0;
        }
    `,
};

styles.iconProps = {
    ...styles.iconProps,
    css: css`
        ${styles.iconProps?.css}
        width: 20px;
        height: auto;
    `,
};

styles.slideCenteringWrapperStyles = {
    ...styles.slideCenteringWrapperStyles,
    css: css`
        ${styles.slideCenteringWrapperStyles?.css};
        width: 100%;
        padding: 0 0 20px;
    `,
};

styles.headingText = {
    ...styles.headingText,
    css: css`
        ${styles.headingText?.css}

        p {
            font-size: 18px;
            line-height: 24px;
            ${mediaQueriesBP.maxMD} {
                font-size: 16px;
                line-height: 19px;
            }
        }
    `,
};

styles.subheadingText = {
    ...styles.subheadingText,
    css: css`
        ${styles.subheadingText?.css}

        p {
            font-size: 18px;
            line-height: 24px;
            ${mediaQueriesBP.maxMD} {
                font-size: 16px;
                line-height: 19px;
            }
        }
    `,
    mergeCss: true,
};
